module.exports = __webpack_public_path__ + "img/mainBanner.png?c0be9c87e0e95a17cd69fb074bba0ae1";